import type { ReactNode } from 'react';

type Props = {
    title: string;
    outlined?: boolean;
    children: ReactNode;
};

export const SectionCard: React.FC<Props> = ({ children, outlined = false, title }) => (
    <div
        data-testid="section-card"
        className={
            outlined
                ? 'flex flex-col gap-6 rounded-md border border-grey-stroke bg-white p-6'
                : 'flex flex-col gap-6 rounded bg-surface-light p-4'
        }
    >
        <p className={outlined ? 'text-sm font-bold text-midnight' : 'text-sm font-medium text-midnight'}>{title}</p>
        {children}
    </div>
);
